import { Locales } from '../models/locales.model'

const locales = {
  'en-CA': {
    logo: 'Live Well Naturally',
    select: 'Please select your location',
    international: 'International',
    confirm_age1: 'I confirm that I am',
    confirm_age2: 'years of age or older',
    confirm_int: 'I confirm I am of legal age in my jurisdiction',
    shared: 'This is not a shared device – remember me for 30 days',
    enter: 'ENTER',
    consent: `You consent to our use of location services to display content relevant to you. You may adjust your location manually at any time in the future. 
    By entering our website you confirm you're of the legal age in your current location.`,
  },
  'fr-CA': {
    logo: 'Bien naturellement',
    select: 'Sélectionnez votre emplacement',
    international: 'À l\'extérieur du Canada',
    confirm_age1: 'Je confirme que j\'ai',
    confirm_age2: 'ans ou plus.',
    confirm_int: 'Je confirme avoir l\'âge légal dans ma juridiction.',
    shared: 'Ceci n\'est pas un appareil partagé - mémorisez-le pendant 30 jours.',
    enter: 'Entrez le site Web',
    consent: `Vous consentez à ce que nous utilisions les services de localisation pour afficher du contenu qui vous concerne.
     Vous pouvez ajuster votre emplacement manuellement à tout moment à l'avenir.
     En entrant dans Bien Naturellement, vous confirmez que vous avez l'âge légal dans votre emplacement actuel et acceptez notre politique de confidentialité et nos conditions d'utilisation.`,
  },
}

const locale: Locales = process.env.LANGUAGE || Locales.EN

export const translate = (key) => locales[locale]?.[key] || ''
